<template>
  <v-dialog v-model="estado_dialog" width="500" persistent>
    <v-card>
      <v-card-title> Aseguradora RESURRECION </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col>
              <v-text-field
                v-model="dui"
                label="DUI"
                outlined
                dense
                hide-details
                :rules="rule"
                :disabled="dui_dis && !puedeEditar"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="cerrarDialog()">Cerrar</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="validarId()"
          v-if="puedeEditar || campos_completos"
          >Guardar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      valid: true,
      id_cierre_resurrecion: 0,
      dui: "",
      estatus_asistencia: "",
      rule: [(v) => !!v || "Campos obligatorios"],
      campos_completos: true,
      /////
      dui_dis: false,
    };
  },
  computed: {
    puedeEditar() {
      return (
        this.$store.state.usuario.rol == "Team Leader Cabina" ||
        this.$store.state.usuario.rol == "Administrador"
      );
    },
  },
  props: ["estado_dialog", "id_cabina"],
  methods: {
    listarDatos(estatus_asistencia) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      this.estatus_asistencia = estatus_asistencia;

      axios
        .get("api/CierreResurreccion/Listar/" + this.id_cabina, configuracion)
        .then((response) => {
          if (response.data.length > 0) {
            this.id_cierre_resurrecion = response.data[0].id_cierre_resurrecion;
            this.dui = response.data[0].dui;

            if (
              this.$store.state.usuario.idUsuario == 1 ||
              this.$store.state.usuario.idUsuario == 5 ||
              this.$store.state.usuario.idUsuario == 1007 ||
              this.$store.state.usuario.idUsuario == 1009 ||
              this.$store.state.usuario.idUsuario == 1011
            ) {
              return;
            }

            if (this.dui.length > 0) {
              this.campos_completos = false;
            }

            if (this.dui.length > 0) {
              this.dui_dis = true;
            }
          }
        });
    },
    validarId() {
      if (this.id_cierre_resurrecion == 0) {
        this.crearRegistro();
      } else if (this.id_cierre_resurrecion > 0) {
        this.actualizarRegistro();
      }
    },
    crearRegistro() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .post(
          "api/CierreResurreccion/Crear",
          {
            idCabina: this.id_cabina,
            dui: this.dui,
          },
          configuracion,
        )
        .then(() => {
          this.cerrarDialog();
        });
    },
    actualizarRegistro() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      if (this.estatus_asistencia == "FINALIZADO") {
        if (this.$refs.form.validate()) {
          axios
            .put(
              "api/CierreResurreccion/Actualizar",
              {
                id_cierre_resurrecion: this.id_cierre_resurrecion,
                idCabina: this.id_cabina,
                dui: this.dui,
              },
              configuracion,
            )
            .then(() => {
              this.cerrarDialog();
            });
        }
      } else {
        axios
          .put(
            "api/CierreResurreccion/Actualizar",
            {
              id_cierre_resurrecion: this.id_cierre_resurrecion,
              idCabina: this.id_cabina,
              dui: this.dui,
            },
            configuracion,
          )
          .then(() => {
            this.cerrarDialog();
          });
      }
    },
    cerrarDialog() {
      this.$emit("update:estado_dialog", !this.estado_dialog);
      this.id_cierre_resurrecion = 0;
      this.dui = "";
      this.$refs.form.resetValidation();
    },
  },
};
</script>
